import Auth from "./auth";

export const authInstance = Auth.getOrCreate();
